import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import Logo from "../../../../../styles/img/custom/renault-top-logo.png";
import {
    UiTopNavBarWr,
    UiMobileNavBar,
    UiHeaderLogo,
} from "./UiTopNavElements";
import UiTopNavItem from "./UiTopNavElements";
// import { userTypes } from "../../../../_redux/_constants/user.constants";
import { isMobile } from "react-device-detect";
// import { socket } from "../../../../../_helpers/support.services";
import { Context } from "../../../../../_context/Store";
import UiChatBot from "../../../chat-bot/UiChatBot";
// import ChatLink from "../../../../../styles/img/chat-link.png"
import NavHelp from "../../../../../styles/img/nav-help-icon.png";
import { createHubConnection } from "../../../../../_helpers/support.services";
import {
    participantJobRoleIds,
    contextApiActions,
    participantTypeIds,
    isShopOnlyJobRole,
} from "../../../../../_redux/_constants";
import {
    campaignGetAllAreaManagerDealersRequest,
    campaignGetAreaManagerDealersRequest,
    campaignGetParticipantsByDealerRequest,
    campaignVChangeRole,
    getParticipantProfileComplete,
    getParticipantProfileRequest,
    getUSerDetailsRequest,
    userAccountLogUserLogStatusRequest,
    userDeviceRequest,
} from "../../../../../_redux/_actions";
import UiTopNavSelect from "./UiTopNavSelect";
import UiNavbarTopSelect from "../../../../_uiComponents/form/UiNavbarTopSelect";
import UiDealerSelect from "../../UiDealerSelect";

export default function TopNavBar(props) {
    const [isActive, setActive] = useState(false);
    const [topLogo, setToplogo] = useState(true);
    const [whiteLogo, setWhiteLogo] = useState(false);
    const [state, dispatch] = useContext(Context);
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [selectArea, setSelectArea] = useState("15");
    const [selectTradePartManager, setSelectTradePartManager] = useState([]);

    const actionDispatch = useDispatch();
    const navigate = useNavigate();

    const newRef = useRef(null);
    const location = useLocation();

    const {
        userProfileDetails,
        areaManagerDealers,
        isChangeRole,
        allAreaManagerDealers,
    } = useSelector((state) => {
        return {
            userProfileDetails: state.auth.userProfileDetails,
            areaManagerDealers: state.campaign,
            isChangeRole: state.campaign.isChangeRole,
            allAreaManagerDealers: state.campaign.allAreaManagerDealers,
        };
    });
    
    const jobRoles = [
        { value: 15, label: "Service Manager" },
        { value: 14, label: "Service Advisor" },
        { value: 23, label: "Trade Parts Manager " },
        { value: 20, label: "Service Area Manager " },
        { value: 24, label: "National Manager" },
        // { value: 31, label: "LCV Manager" },
        // { value: 22, label: "Trade Area Manager" },
        { value: 36, label: "Pro Plus Sales Specialist" },
        { value: 38, label: "Fleet Manager" },
        { value: 39, label: "General Manager" },
        { value: 37, label: "Pro Plus Manager" },
        { value: 40, label: "LCV Admin" },
        { value: 42, label: "LCV Area Manager" },
        { value: 25, label: "Trade Rep" },
    ];

    const areas = [
        { value: 11, label: "11" },
        { value: 12, label: "12" },
        { value: 13, label: "13" },
        { value: 14, label: "14" },
        { value: 15, label: "15" },
        { value: 16, label: "16" },
        { value: 17, label: "17 " },
    ];

    const [selectedValue, setSelectedValue] = useState(24);
   
    const lcvDealerJobRoleIds = [37, 38, 39,36,40,42];
    const shouldHideRoleDropdown =
        !isChangeRole &&
        lcvDealerJobRoleIds.includes(Number(userProfileDetails?.jobRoleId));

    useEffect(() => {
        if (
            auth?.userProfileDetails?.jobRoleId ===
            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER
        ) {
            // setSelectTradePartManager(auth?.userProfileDetails?.dealerships[0]);
        }
    }, [userProfileDetails]);

    const handleChange = (item) => {
        setSelectedValue(item);
        let data = null;

        if (item === 36 || item === 37 || item === 38 || item === 39 || item === 40 || item === 42) {
            const lcvDealers = (allAreaManagerDealers || []).filter(
                (dealer) => dealer.isLcvDealer === true,
            );
           
            const defaultDealer = lcvDealers[0] ?? null;
            // Always reset dealer dropdown to first LCV option on role change
            setSelectedDealer(
                defaultDealer
                    ? {
                          value:
                              defaultDealer.id,
                          label: defaultDealer.name,
                      }
                    : null,
            );
            data = {
                data: {
                    ...userProfileDetails,
                    jobRoleId: item,
                    dealerships: userProfileDetails.dealerships.map(
                        (dealer) => ({
                            ...dealer,                                                        
                                dealerId:
                                    defaultDealer?.id,
                                dealerName: defaultDealer?.name,
                        }),
                    ),
                },
            };
        }

      

        if (item === 15 || item === 14 || item === 23 ) {
            // Clear LCV selection so SM/TPM dealer list starts fresh
            setSelectedDealer(null);
            const defaultDealer = allAreaManagerDealers?.[0];
            data = {
                data: {
                    ...userProfileDetails,
                    jobRoleId: item,
                    dealerships: userProfileDetails.dealerships.map(
                        (dealer) => ({
                            ...dealer,
                            dealerCode: defaultDealer?.code,
                            dealerName: defaultDealer?.name,
                        }),
                    ),
                },
            };
        }
        
        if (item === 24) {
            data = {
                data: {
                    ...userProfileDetails,
                    jobRoleId: item,
                },
            };
        }
        if (item === 31) {
            data = {
                data: {
                    ...userProfileDetails,
                    jobRoleId: item,
                },
            };
        }
        if (item === 20) {
            data = {
                data: {
                    ...userProfileDetails,
                    jobRoleId: item,
                },
            };
        }
        if (item === 22) {
            data = {
                data: {
                    ...userProfileDetails,
                    jobRoleId: item,
                },
            };
        }
        if (item === 25) {
            data = {
                data: {
                    ...userProfileDetails,
                    jobRoleId: item,
                },
            };
        }
      
        
        actionDispatch(getParticipantProfileComplete(data));
        actionDispatch(campaignVChangeRole(true));
        dispatch({
            type: "CHANGE_ROLE",
            payload: { changeRole: true },
        });
    };

    const handleAreaChange = (value) => {
        if (location.pathname !== "/app/home") {
            navigate("/app/home");
        }

        setSelectArea(value);
        let data = null;
        data = {
            data: {
                ...userProfileDetails,
                area: value,
            },
        };
        actionDispatch(getParticipantProfileComplete(data));
    };

    const handleChangeDealer = (value) => {
        if (location.pathname !== "/app/home") {
            navigate("/app/home");
        }
        setSelectedDealer(value);
        const isLcvManagerRole =
            lcvDealerJobRoleIds.includes(selectedValue) ||
            lcvDealerJobRoleIds.includes(
                Number(userProfileDetails?.jobRoleId),
            );
        let data = null;
        
        data = {
            data: {
                ...userProfileDetails,
                dealerships: userProfileDetails.dealerships.map((dealer) => ({
                    ...dealer,
                    dealershipId: dealer.dealershipId ?? dealer.dealerId,
                    ...(isLcvManagerRole
                        ? { dealerId: value?.value }
                        : { dealerCode: value?.value }),
                    dealerName: value?.label,
                })),
            },
        };
        actionDispatch(getParticipantProfileComplete(data));
    };

    const handleChangeServiceManager = (value) => {
        let data = null;
        data = {
            data: {
                ...userProfileDetails,
                isCheckSecondDealer: true,
                secondDealerCode: value,
            },
        };
        actionDispatch(getParticipantProfileComplete(data));
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    });

    useEffect(() => {
        actionDispatch(getParticipantProfileRequest());
        actionDispatch(getUSerDetailsRequest());
        //actionDispatch(campaignGetParticipantsByDealerRequest({dealerCode: 1}));
        if (location.pathname === "/app/campaigns") {
            if (!auth?.userProfileDetails?.dealerParticipant) {
                navigate("/app/home");
            }
        }

        actionDispatch(
            userDeviceRequest({ devicedUsedTypeId: isMobile ? 1 : 2 }),
        );
        actionDispatch(userAccountLogUserLogStatusRequest({ active: true }));
    }, []);

    const handleOutsideClick = (e) => {
        if (newRef.current && !newRef.current.contains(e.target)) {
            setActive(false);
        }
    };

    const { auth } = useSelector((state) => {
        return {
            auth: state.auth,
        };
    });

    useEffect(() => {
        let connection = null;
        if (typeof auth?.userProfileDetails.userId != "undefined") {
            connection = createHubConnection(auth?.userProfileDetails.userId);

            connection
                .start()
                .then(() => {
                    dispatch({
                        type: contextApiActions.SET_SIGNALR_CONNECTTION,
                        payload: connection,
                    });
                })
                .catch((err) => console.log(err));
        }

        return () => {
            if (connection) {
                connection.stop();
            }
        };
    }, [auth?.userProfileDetails]);

    const mobileSidebarToggle = () => {
        setActive(!isActive);
    };
    const toggleClose = () => {
        setActive(false);
    };

    useEffect(function () {
        window.addEventListener("scroll", () => {
            if (!isMobile) {
                let scrollTop = window.scrollY;
                let activeLink = document.querySelector(
                    ".sb-slider-bottom-line",
                );

                if (activeLink !== null) {
                    if (scrollTop >= activeLink.offsetTop) {
                        setToplogo(false);
                        setWhiteLogo(true);
                    } else {
                        setToplogo(true);
                        setWhiteLogo(false);
                    }
                }
            }
        });
    }, []);

    const showChatBox = () => {
        // setActive(false);
        // dispatch({
        //     type: "CHAT_BOX_MODAL",
        //     payload: {
        //         show: true,
        //         children: <UiChatBot />,
        //     },
        // });
        dispatch({
            type: "FOOTER_CONTENT_MODAL",
            payload: {
                show: true,
                children: (
                    <>
                        <h3 className="sb-chat-support-content">
                            Got a question or need help to get you up and
                            running?
                        </h3>
                        {userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT ? (
                            <h6 className="sb-chat-support-content-email">
                                Message us at: support@rgequipe.com{" "}
                            </h6>
                        ) : userProfileDetails?.jobRoleId ==
                              participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_EQUIPE_CUSTOMER ||
                          userProfileDetails?.jobRoleId ==
                              participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_GROUP_PARTS_MANAGER ||
                          userProfileDetails?.jobRoleId ==
                              participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_EXECUTIVE ||
                          userProfileDetails?.jobRoleId ==
                              participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_MANAGER ? (
                            <h6 className="sb-chat-support-content-email">
                                Message us at: Support@MyRGRewards.com{" "}
                            </h6>
                        ) : (
                            <h6 className="sb-chat-support-content-email">
                                Message us at: support@renaultTLC.com{" "}
                            </h6>
                        )}
                    </>
                ),
            },
        });
    };

    useEffect(() => {
        if (
            auth?.userProfileDetails?.jobRoleId ===
            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER
        ) {
            actionDispatch(
                campaignGetAllAreaManagerDealersRequest({
                    particpantId: auth?.userProfileDetails?.participantIds[0],
                    areaId: null,
                }),
            );
        }
    }, [auth?.userProfileDetails?.jobRoleId]);

    return (
        <>
            <UiMobileNavBar toggle={mobileSidebarToggle} />
            <UiHeaderLogo
                onClick={() => navigate("/app/home")}
                logo={Logo}
                whiteLogo={whiteLogo}
                topLogo={topLogo}
                // permission={
                //     auth?.userProfileDetails?.roleId ==
                //     participantTypeIds.PARTICIPANT
                // }
            />

            <UiTopNavBarWr
                isActive={isActive}
                close={toggleClose}
                ref={newRef}
                permission={
                    auth?.userProfileDetails?.jobRoleId ===
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                    auth?.userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT
                }
            >
                <UiTopNavItem
                    onClick={toggleClose}
                    label="Home"
                    pathname={"home"}
                />
                {/* An unresolved job role hides Campaigns rather than showing it. Defaulting to
                    visible would flash the item to a retail winner while their profile loads. */}
                {auth?.userProfileDetails?.jobRoleId === undefined ||
                auth?.userProfileDetails?.jobRoleId === null ||
                auth?.userProfileDetails?.jobRoleId === "" ||
                (auth?.userProfileDetails?.dealerParticipant &&
                    auth?.userProfileDetails?.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_EQUIPE_CUSTOMER) ||
                (auth?.userProfileDetails?.dealerParticipant &&
                    auth?.userProfileDetails?.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_GROUP_PARTS_MANAGER) ||
                (auth?.userProfileDetails?.dealerParticipant &&
                    auth?.userProfileDetails?.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_EXECUTIVE) ||
                (auth?.userProfileDetails?.dealerParticipant &&
                    auth?.userProfileDetails?.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_MANAGER) ||
                (auth?.userProfileDetails?.roleId ===
                    participantTypeIds.TLC_PARTICIPANT &&
                    auth?.userProfileDetails?.shopOnly === true) ||
                isShopOnlyJobRole(auth?.userProfileDetails?.jobRoleId) ? (
                    ""
                ) : (
                    <UiTopNavItem
                        onClick={toggleClose}
                        label="Campaigns"
                        pathname={"campaigns"}
                    />
                )}
               
                <UiTopNavItem
                    onClick={toggleClose}
                    label="Shop"
                    pathname={"shop/browse-products"}
                />
                

                <UiTopNavItem
                    onClick={toggleClose}
                    label="Points Bank"
                    pathname={"/app/points-banking"}
                />
                <UiTopNavItem
                    onClick={toggleClose}
                    label="Voucher Wallet"
                    pathname={"shop/voucher-wallet"}
                />
                {auth?.userProfileDetails?.jobRoleId ===
                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER &&
                    [1000001, 2000035, 2000588, 2000038, 2013925, 2013935, 2015907].includes(
                        auth?.userProfileDetails?.userId,
                    ) && (
                    <UiTopNavItem
                        onClick={toggleClose}
                        label="AI Analytic"
                        pathname={"/app/insights"}
                    />
                )}
                <UiTopNavItem
                    onClick={showChatBox}
                    label="Help"
                    externalLink
                    clickEvent
                />
                {(isChangeRole ||
                    auth?.userProfileDetails?.jobRoleId ===
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER) &&
                    (selectedValue === 15 ||
                        selectedValue === 14 ||
                        selectedValue === 23 ||
                        selectedValue === 24 ||
                        selectedValue === 20 ||
                        selectedValue === 22 ||
                        selectedValue === 36 ||
                        selectedValue === 37 ||
                        selectedValue === 38 ||
                        selectedValue === 39 ||
                        selectedValue === 40 ||
                        selectedValue === 42 ||
                        selectedValue === 25) && (
                        <>
                            {!shouldHideRoleDropdown && (
                                <div
                                    className={
                                        selectedValue == 24
                                            ? "sb-top-dealer-select-national-manager sb-top-dealer-mobile-select selected-national-manager"
                                            : "sb-top-dealer-select-national-manager sb-top-dealer-mobile-select"
                                    }
                                >
                                    <UiNavbarTopSelect
                                        options={jobRoles}
                                        selectRole={true}
                                        onChange={(e) => {
                                            handleChange(e.value);
                                        }}
                                        defaultValue={{
                                            label: jobRoles[4].label,
                                            value: jobRoles[4].value,
                                        }}
                                    />
                                </div>
                            )}
                            <div className="sb-top-dealer-select-national-manager-sub-options sb-top-dealer-mobile-select">
                                {isChangeRole &&
                                    (selectedValue === 15 ||
                                        selectedValue === 14 ||
                                        selectedValue === 36 ||
                                        selectedValue === 38 ||
                                        selectedValue === 37 ||
                                        selectedValue === 39 ||
                                        selectedValue === 40 ||
                                        selectedValue === 42 ||
                                        selectedValue === 23) && (
                                        <UiDealerSelect
                                        dealerOptions={
                                            (
                                                selectedValue === 36 ||
                                                selectedValue === 37 ||
                                                selectedValue === 38 ||
                                                selectedValue === 39 ||
                                                selectedValue === 40 ||
                                                selectedValue === 42
                                                    ? allAreaManagerDealers.filter(
                                                          (dealer) =>
                                                              dealer.isLcvDealer ===
                                                              true,
                                                      )
                                                    : allAreaManagerDealers
                                            ).map((dealership) => ({
                                                value: lcvDealerJobRoleIds.includes(selectedValue)
                                                ? dealership.id
                                                : dealership.code,
                                                label: dealership.name,
                                            }))
                                        }

                                            // dealerOptions={allAreaManagerDealers.map(
                                            //     (dealerships) => {
                                            //         return {
                                            //             value: dealerships.code,
                                            //             label: dealerships.name,
                                            //         };
                                            //     },
                                            // )}
                                            dealerships={
                                                selectedValue === 36 ||
                                                selectedValue === 37 ||
                                                selectedValue === 38 ||
                                                selectedValue === 39 ||
                                                selectedValue === 40 ||
                                                selectedValue === 42
                                                    ? allAreaManagerDealers.filter(
                                                          (dealer) =>
                                                              dealer.isLcvDealer ===
                                                              true,
                                                      )
                                                    : allAreaManagerDealers
                                            }
                                            // dealerships={allAreaManagerDealers}
                                            isDashBoard={false}
                                            isAreaManager={false}
                                            selectDealer={true}
                                            onChange={(value) => {
                                                handleChangeDealer(value);
                                            }}
                                            selectedDealer={selectedDealer}
                                        />
                                    )}
                                {(selectedValue === 20 ||
                                    selectedValue === 22 ||
                                    selectedValue === 25) && (
                                    <UiNavbarTopSelect
                                        options={areas}
                                        onChange={(e) => {
                                            handleAreaChange(e.value);
                                        }}
                                        defaultValue={{
                                            label: areas[0].label,
                                            value: areas[0].value,
                                        }}
                                    />
                                )}
                            </div>
                        </>
                    )}
                {!isChangeRole &&
                    auth?.userProfileDetails?.jobRoleId ===
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                    auth?.userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT && (
                        <div className="sb-top-dealer-mobile-select">
                            <UiTopNavSelect
                                dealerOptions={auth?.userProfileDetails?.dealerships.map(
                                    (dealerships) => {
                                        return {
                                            value: dealerships.dealerCode,
                                            label: dealerships.dealerName,
                                        };
                                    },
                                )}
                                selectDealer={true}
                                dealerships={
                                    auth?.userProfileDetails?.dealerships
                                }
                            />
                        </div>
                    )}
            </UiTopNavBarWr>
            <div
    className={
        !isChangeRole
            ? "sb-chat-bot-with-no-dealer"
            : (
                  auth?.userProfileDetails?.jobRoleId ===
                      participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER ||
                  auth?.userProfileDetails?.jobRoleId ===
                      participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR ||
                  auth?.userProfileDetails?.jobRoleId ===
                      participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER ||
                  auth?.userProfileDetails?.jobRoleId ===
                      participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER ||
                  auth?.userProfileDetails?.jobRoleId === 37 ||
                  auth?.userProfileDetails?.jobRoleId === 38 ||
                  auth?.userProfileDetails?.jobRoleId === 39 ||
                  auth?.userProfileDetails?.jobRoleId === 40 ||
                  auth?.userProfileDetails?.jobRoleId === 42 ||
                  auth?.userProfileDetails?.jobRoleId === 36 ||
                  (auth?.userProfileDetails?.roleId ===
                      participantTypeIds.PARTICIPANT &&
                      auth?.userProfileDetails?.jobRoleId ===
                          participantJobRoleIds.TLC_TRADE_REP)
              )
                ? "sb-chat-bot-with-dealer"
                : "sb-chat-bot-with-no-dealer"
    }
>
                <div
                    className={
                        isChangeRole ||
                        auth?.userProfileDetails?.jobRoleId ===
                            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER ||
                        auth?.userProfileDetails?.jobRoleId ===
                            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER
                            ? "sb-show-chat-bot-manager"
                            : "sb-show-chat-bot"
                    }
                    onClick={showChatBox}
                >
                    <img src={NavHelp} />
                </div>
            </div>

            {(isChangeRole ||
                auth?.userProfileDetails?.jobRoleId ===
                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER) &&
                (selectedValue === 15 ||
                    selectedValue === 14 ||
                    selectedValue === 23 ||
                    selectedValue === 24 ||
                    selectedValue === 20 ||
                    selectedValue === 22 ||
                    selectedValue === 36 ||
                    selectedValue === 37 ||
                    selectedValue === 38 ||
                    selectedValue === 39 ||
                    selectedValue === 40 ||
                    selectedValue === 42 ||
                    selectedValue === 25) && (
                    <>
                        {!shouldHideRoleDropdown && (
                            <div
                                className={
                                    selectedValue == 24 
                                    
                                        ? "sb-top-dealer-select-national-manager selected-national-manager"
                                        : "sb-top-dealer-select-national-manager "
                                }
                            >
                                <UiNavbarTopSelect
                                    options={jobRoles}
                                    selectRole={true}
                                    onChange={(e) => {
                                        handleChange(e.value);
                                    }}
                                    defaultValue={{
                                        label: jobRoles[4].label,
                                        value: jobRoles[4].value,
                                    }}
                                />
                            </div>
                        )}
                        <div className="sb-top-dealer-select-national-manager-sub-options">
                            {isChangeRole &&
                                (selectedValue === 15 ||
                                    selectedValue === 14 ||
                                    selectedValue === 36 ||
                                    selectedValue === 37 ||
                                    selectedValue === 38 ||
                                    selectedValue === 39 ||
                                    selectedValue === 40 ||
                                    selectedValue === 42 ||
                                    selectedValue === 23) && (
                                    <UiDealerSelect
                                        dealerOptions={
                                            (
                                                selectedValue === 36 ||
                                                selectedValue === 37 ||
                                                selectedValue === 38 ||
                                                selectedValue === 39 ||
                                                selectedValue === 40 ||
                                                selectedValue === 42
                                                    ? allAreaManagerDealers.filter(
                                                          (dealer) =>
                                                              dealer.isLcvDealer ===
                                                              true,
                                                      )
                                                    : allAreaManagerDealers
                                            ).map((dealership) => ({
                                                value: lcvDealerJobRoleIds.includes(selectedValue)
                                                ? dealership.id
                                                : dealership.code,
                                                label: dealership.name,
                                            }))
                                        }
                                        dealerships={
                                            selectedValue === 36 ||
                                            selectedValue === 37 ||
                                            selectedValue === 38 ||
                                            selectedValue === 39 ||
                                            selectedValue === 40 ||
                                            selectedValue === 42
                                                ? allAreaManagerDealers.filter(
                                                      (dealer) =>
                                                          dealer.isLcvDealer ===
                                                          true,
                                                  )
                                                : allAreaManagerDealers
                                        }
                                        isDashBoard={false}
                                        isAreaManager={false}
                                        selectDealer={true}
                                        onChange={(value) => {
                                            handleChangeDealer(value);
                                        }}
                                        selectedDealer={selectedDealer}
                                    />
                                )}
                            {(selectedValue === 20 ||
                                selectedValue === 22 ||
                                selectedValue === 25) && (
                                <UiNavbarTopSelect
                                    options={areas}
                                    onChange={(e) => {
                                        handleAreaChange(e.value);
                                    }}
                                    defaultValue={{
                                        label: areas[0].label,
                                        value: areas[0].value,
                                    }}
                                />
                            )}
                        </div>
                    </>
                )}

            {!isChangeRole &&
                auth?.userProfileDetails?.jobRoleId ===
                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                auth?.userProfileDetails.roleId ==
                    participantTypeIds.PARTICIPANT && (
                    <div className="sb-top-dealer-select">
                        <UiNavbarTopSelect
                            options={auth?.userProfileDetails?.dealerships.map(
                                (dealerships) => {
                                    return {
                                        value: dealerships.dealerCode,
                                        label: dealerships.dealerName,
                                    };
                                },
                            )}
                            isDashBoard={false}
                            isAreaManager={false}
                            onChange={(e) => {
                                handleChangeServiceManager(e.value);
                                setSelectTradePartManager(e.value);
                            }}
                            selectDealer={true}
                            dealerships={auth?.userProfileDetails?.dealerships}
                        />
                    </div>
                )}
            {!isChangeRole &&
                auth?.userProfileDetails?.jobRoleId ===
                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER &&
                auth?.userProfileDetails.roleId ==
                    participantTypeIds.PARTICIPANT && (
                    <div className="sb-top-dealer-select">
                        <UiNavbarTopSelect
                            options={auth?.userProfileDetails?.dealerships.map(
                                (dealerships) => {
                                    return {
                                        value: dealerships.dealerCode,
                                        label: dealerships.dealerName,
                                    };
                                },
                            )}
                            onChange={(e) => {
                                handleChangeServiceManager(e.value);
                                setSelectTradePartManager(e.value);
                            }}
                            selectDealer={true}
                            defaultValue={{
                                label: areas[0].label,
                                value: areas[0].value,
                            }}
                            dealerships={auth?.userProfileDetails?.dealerships}
                        />
                    </div>
                )}
        </>
    );
}
